import { render, staticRenderFns } from "./IPuzzle.vue?vue&type=template&id=3eccb73e&"
import script from "./IPuzzle.vue?vue&type=script&lang=ts&"
export * from "./IPuzzle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports